import React, { useMemo } from 'react';

import { className, Container } from 'design-system';

import TransitionLink from '../TransitionLink';
import SearchFormComponent from '../SearchFormComponent';

import style from './style.module.scss';

function HeaderDropdownItem({
    label,
    href,
    description,
    liClassName,
    openInNewWindow,
    onClick,
}) {
    return (
        <li
            className={`${style['row__col']} ${liClassName ? liClassName : ''
                }`}>
            <TransitionLink
                {...className(
                    `${style.item} h6 d-block w-100 text-decoration-none`,
                )}
                activeClassName={style['link-active']}
                to={href}
                title={label}
                target={openInNewWindow ? '_blank' : null}
                onClick={onClick}>
                <span {...className(`body ${style['item__name']}`)}>
                    {label}
                </span>
                {description ? (
                    <span
                        {...className(
                            `d-block mt-2 ${style['item__description']}`,
                        )}>
                        {description}
                    </span>
                ) : null}
            </TransitionLink>
        </li>
    );
}

export default function HeaderDropdownComponent({
    items,
    onClick,
    align,
    language,
}) {
    const [fullWidthItems, otherItems] = useMemo(() => {
        let columns = [];
        items.forEach((item) => {
            if (
                item.column &&
                item.column > 0 &&
                columns.indexOf(item.column) === -1
            ) {
                columns.push(item.column);
            }
        });

        let fullWidthItems = items.filter((item) => item.column === 0);
        let otherItems = columns.length
            ? columns
                .map((column) =>
                    items.filter((item) => item.column === column),
                )
                .filter((items) => !!items.length)
            : [];

        return [
            align === 'right' && otherItems.length
                ? otherItems[0]
                : fullWidthItems,
            align === 'right' ? [] : otherItems,
        ];
    }, [items, language, align]);

    const onClickItem = (e, item) => {
        if (typeof item.onClick === 'function') {
            item.onClick(e);
        }

        if (typeof onClick === 'function') {
            onClick(e);
        }
    };

    return (
        <div data-datocms-noindex {...className(`${style.wrapper}`)}>
            <Container isFluid={align === 'right'}>
                {fullWidthItems?.length ? (
                    <ul
                        {...className(
                            `list-unstyled mb-3 ${style[`align-${align}`]}`,
                        )}>
                        {fullWidthItems.map((item, i) =>
                            item.label && item.label === 'searchform' ? (
                                <SearchFormComponent
                                    key={i}
                                    action={item.href}
                                />
                            ) : (
                                <HeaderDropdownItem
                                    key={i}
                                    {...item}
                                    onClick={(e) => onClickItem(e, item)}
                                />
                            ),
                        )}
                    </ul>
                ) : null}
                {otherItems && otherItems.length ? (
                    <div {...className(`d-lg-flex ${style.row}`)}>
                        {otherItems.map((items, i) => (
                            <ul
                                key={i}
                                {...className(
                                    `list-unstyled w-100 ${style['other-items-list']}`,
                                )}>
                                {items.map((item, ii) => {
                                    return (
                                        <HeaderDropdownItem
                                            key={ii}
                                            {...item}
                                            liClassName={
                                                ii === 0
                                                    ? style['first-item']
                                                    : ''
                                            }
                                            onClick={(e) =>
                                                onClickItem(e, item)
                                            }
                                        />
                                    );
                                })}
                            </ul>
                        ))}
                    </div>
                ) : null}
            </Container>
        </div>
    );
}
